import { JobTypesAdmin } from "@/components/admin/JobTypesAdmin";

export function SettingsJobTypesPage() {
  return <JobTypesAdmin />;
}
